module.exports = __webpack_public_path__ + "media/images/application/social_sharing/twitter-dc9ab86759a997f1c498fa97676bbca6.png";